














































































































































































































































































































































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import AbpBase from '../../lib/abpbase'
import VipApi from '@/api/vip/list'
import distributorApi from '@/api/distributor/index.ts'
@Component
export default class DistributorDetail extends AbpBase {
  columns: any[] = [
    {
      title: '订单编号',
      key: 'orderNo',
      align: 'center',
    },
    {
      title: '会员名字',
      key: 'name',
      align: 'center',
    },
    {
      title: '订单金额',
      key: 'orderAmount',
      align: 'center',
    },
    {
      title: '收益金额',
      key: 'income',
      align: 'center',
    },
    {
      title: '分佣比例',
      slot: 'percent',
      align: 'center',
    },
    {
      title: '提交时间',
      slot: 'orderTime',
      align: 'center',
    },
    {
      title: '收益状态',
      slot: 'incomeStatus',
      align: 'center',
    },
  ]
  tableData: any[] = []
  table: any = {
    currentPage: 1,
    totalCount: 0,
    pageSize: 10,
  }

  columns2: any[] = [
    {
      title: '提现金额',
      key: 'withdrawnCash',
      align: 'center',
    },
    {
      title: '申请时间',
      slot: 'creationTime',
      align: 'center',
    },
    {
      title: '审核说明',
      key: 'description',
      align: 'center',
    },
    {
      title: '审核时间',
      slot: 'checkTime',
      align: 'center',
    },
    {
      title: '审核状态',
      slot: 'reviewStatus',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      width: 150,
      align: 'center',
    },
  ]
  tableData2: any[] = []
  table2: any = {
    currentPage: 1,
    totalCount: 0,
    pageSize: 10,
  }

  columns3: any[] = [
    {
      title: '用户ID',
      key: 'id',
      align: 'center',
    },
    {
      title: '昵称',
      key: 'nickName',
      align: 'center',
    },
    {
      title: '会员等级',
      key: 'level',
      align: 'center',
    },
    {
      title: '积分',
      key: 'bonus',
      align: 'center',
    },
    {
      title: '级别链',
      key: 'levelChain',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      width: 150,
      align: 'center',
    },
  ]
  tableData3: any[] = []
  table3: any = {
    currentPage: 1,
    totalCount: 0,
    pageSize: 10,
  }

  vipInfos: any = {}
  distributionInfos: any = {}

  showModal = false

  verify = {
    reviewStatus: 1,
    failReason: null,
  }
  ruleVerify = {
    failReason: [
      { required: true, validator: this.validateRemark, trigger: 'blur' },
    ],
  }

  validateRemark(rule, value, callback) {
    if (this.verify.reviewStatus == 2 && !value) {
      return callback(new Error('请输入备注'))
    }
    callback()
  }
  verifyId = null
  loadingBtn = false

  created() {
    this.getVipInfos()
    this.getDistributionInfo()
    this.getDistributionOrder()
    this.getWithdrawRecord()
    // if (this.isEveProject) {
      this.getDistributionTeam()
    // }
  }

  /**
   * 获取会员详情
   */
  getVipInfos() {
    let id = this.$route.query['id']
    if (id) {
      VipApi.getVipInfos(id.toString()).then((res) => {
        this.vipInfos = res.data
      })
    }
  }

  /**
   * 获取指定分销员信息
   */
  getDistributionInfo() {
    let id = this.$route.query['id']
    if (id) {
      distributorApi.getDistributionInfo(id.toString()).then((res) => {
        this.distributionInfos = res.data
      })
    }
  }

  /**
   * 获取分销员分销订单记录
   */
  getDistributionOrder() {
    let id = this.$route.query['id']
    if (id) {
      let { table } = this
      distributorApi
        .getDistributionOrder(table.pageSize, table.currentPage, id.toString())
        .then((res) => {
          if (res.data) {
            this.tableData = res.data.items
            table.totalCount = res.data.totalCount
          }
        })
    }
  }

  /**
   * 获取分销员提现申请记录
   */
  getWithdrawRecord() {
    let id = this.$route.query['id']
    if (id) {
      distributorApi
        .getWithdrawRecord(
          this.table2.pageSize,
          this.table2.currentPage,
          id.toString()
        )
        .then((res) => {
          this.tableData2 = res.data.items
          this.table2.totalCount = res.data.totalCount
        })
    }
  }

  /*
  获取分销员的团队
  */
  getDistributionTeam() {
    let id = this.$route.query['id']
    if (id) {
      distributorApi
        .getDistributionTeam(
          this.table3.pageSize,
          this.table3.currentPage,
          id.toString()
        )
        .then((res) => {
          // console.log('团队列表', res)
          this.tableData3 = res.data.items
          this.table3.totalCount = res.data.totalCount
        })
    }
  }

  showModalFn(row) {
    this.showModal = true
    this.verifyId = row.id
  }

  /**
   * 提交审核
   */
  saveFn() {
    let verifyForm: any = this.$refs.verifyForm
    verifyForm.validate((valid) => {
      if (valid && this.verifyId) {
        this.loadingBtn = true
        distributorApi
          .verifyWithdrawRecord(this.verifyId, this.verify)
          .then((res) => {
            this.cancelFn()
            this.getWithdrawRecord()
          })
          .catch((err) => {
            this.loadingBtn = false
          })
      }
    })
  }

  /**
   * 取消审核
   */
  cancelFn() {
    this.showModal = false
    this.verify = {
      reviewStatus: 1,
      failReason: null,
    }
    this.verifyId = null
    this.loadingBtn = false
  }

  /**
   * 更改页数
   */
  changePage(e, which, click?) {
    switch (which) {
      case 1:
        this.table.currentPage = e
        break
      default:
        this['table' + which].currentPage = e
        break
    }
    if (this[click]) {
      this[click]()
    }
  }

  incomeStatusDisplayName(incomeStatus) {
    switch(incomeStatus){
      case 0:
        return "待结算"
      case 1:
        return "已结算"
      case 2:
        return "已取消"
      default:
        return ""
    }
  }
}
